const common: Record<string, string> = {
  // Nav
  'nav.solutions': 'Solutions',
  'nav.technology': 'Technologie',
  'nav.advantages': 'Avantages',
  'nav.contact': 'Contact',
  'nav.getInfo': 'Demander un devis',
  'nav.home': 'Accueil',
  'nav.services': 'Services',
  'nav.process': 'Processus',
  'nav.vision': 'Vision',
  'nav.back': 'Retour',

  // Hero
  'hero.badge': 'Solution innovante de réparation de bagages',
  'hero.title': 'Réparation de Bagages,',
  'hero.titleHighlight': 'divisez par 3 vos coûts de litiges',
  'hero.description': 'Nouvelle solution professionnelle de réparation de bagages endommagés pour les compagnies aériennes. Intervention rapide, qualité garantie, directement sur le hub Mohammed V.',
  'hero.ctaPrimary': 'Demander un devis',
  'hero.ctaSecondary': 'Découvrir nos services',
  'hero.stat1': 'Réduction des coûts',
  'hero.stat2': 'Temps de réparation',
  'hero.stat3': 'Objectif satisfaction',

  // Instant Impact
  'impact.title': 'Pourquoi payer pour remplacer quand vous pouvez réparer ?',
  'impact.card1Badge': 'Votre système actuel',
  'impact.card1Highlight': 'Remplacement automatique',
  'impact.card1Text': 'Coûts élevés + Logistique lourde + Gâchis écologique',
  'impact.card2Badge': 'Notre solution locale',
  'impact.card2Highlight': 'Réparation express',
  'impact.card2Text': '-40% de coûts + Zéro déchet + Image de marque responsable',
  'impact.cta': 'Calculer vos économies',

  // Services
  'services.badge': 'Nos Solutions',
  'services.title': 'Des Solutions Complètes',
  'services.titleHighlight': 'Pour Vos Passagers',
  'services.subtitle': 'Une gamme complète de services de réparation pour tous types de bagages endommagés lors du transport aérien.',
  'services.fastTrack.title': 'Fast-Track Aéroport',
  'services.fastTrack.description': 'Réparation express directement en zone aéroportuaire. Intervention en 1-2h pour minimiser l\'impact sur vos passagers.',
  'services.fastTrack.feature1': 'Intervention en 1-2 heures',
  'services.fastTrack.feature2': 'Directement en zone aéroportuaire',
  'services.fastTrack.feature3': 'Rapport photo avant/après',
  'services.claims.title': 'Gestion des Litiges',
  'services.claims.description': 'Prise en charge complète des réclamations bagages. De la déclaration PIR à la résolution finale.',
  'services.claims.feature1': 'Déclaration PIR digitalisée',
  'services.claims.feature2': 'Suivi en temps réel',
  'services.claims.feature3': 'Reporting analytique',
  'services.logistics.title': 'Logistique & Livraison',
  'services.logistics.description': 'Service de collecte et livraison premium. Vos passagers récupèrent leur bagage réparé où ils le souhaitent.',
  'services.logistics.feature1': 'Collecte à domicile ou hôtel',
  'services.logistics.feature2': 'Livraison express 24-48h',
  'services.logistics.feature3': 'Suivi GPS en temps réel',

  // Sovereignty
  'sovereignty.badge': 'Avantage Compétitif Air Baggage Repair',
  'sovereignty.title': 'Réparation vs Remplacement',
  'sovereignty.subtitle': 'Pourquoi les compagnies aériennes choisissent Air Baggage Repair plutôt que les solutions de remplacement coûteuses',
  'sovereignty.competitorBadge': 'Solution Classique',
  'sovereignty.competitorTitle': 'Remplacement Systématique',
  'sovereignty.competitorSubtitle': 'La solution traditionnelle des concurrents',
  'sovereignty.competitorPoint1': 'Coût élevé : 250-500€ par bagage remplacé',
  'sovereignty.competitorPoint2': 'Délai long : 7-21 jours d\'attente',
  'sovereignty.competitorPoint3': 'Importation : Dépendance aux fournisseurs étrangers',
  'sovereignty.competitorPoint4': 'Impact environnemental : Déchets et empreinte carbone élevée',
  'sovereignty.competitorPoint5': 'Satisfaction client faible : Passager sans bagage pendant des jours',
  'sovereignty.abrsBadge': 'Solution ABRS',
  'sovereignty.abrsTitle': 'Réparation Locale Premium',
  'sovereignty.abrsSubtitle': 'Notre approche innovante et économique',
  'sovereignty.abrsPoint1': 'Économie estimée de 88% : 30-60€ par réparation',
  'sovereignty.abrsPoint2': 'Rapidité extrême : 1-2h sur site à Mohammed V',
  'sovereignty.abrsPoint3': 'Souveraineté locale : Expertise marocaine, zéro dépendance',
  'sovereignty.abrsPoint4': 'Éco-responsable : -80% d\'empreinte carbone, économie circulaire',
  'sovereignty.abrsPoint5': 'Satisfaction maximale : Passager repart avec son bagage réparé',
  'sovereignty.avgCostLabel': 'Coût moyen par incident',
  'sovereignty.roiTitle': 'Impact Financier Mesurable',
  'sovereignty.roiSubtitle': 'Économies potentielles pour votre compagnie aérienne',
  'sovereignty.roiMetric1': 'Réduction des coûts d\'indemnisation',
  'sovereignty.roiMetric2': 'Délai de résolution moyen',
  'sovereignty.roiMetric3': 'Amélioration satisfaction client',
  'sovereignty.exampleTitle': 'Exemple concret pour 100 incidents bagages/mois :',
  'sovereignty.exampleText': 'Remplacement concurrent : 25 000-50 000€/mois • ABRS Réparation : 3 000-6 000€/mois • Économie annuelle : 264 000-528 000€ + amélioration image de marque',
  'sovereignty.certified': 'Certifié IATA',
  'sovereignty.hub': 'Hub Mohammed V',
  'sovereignty.available': 'Disponible 24/7',
  'sovereignty.cta': 'Consulter notre protocole technique',

  // Engagement National
  'engagement.badge': 'Engagement National',
  'engagement.titlePart1': 'L\'expertise internationale',
  'engagement.titlePart2': 'au service d\'un',
  'engagement.titlePart3': 'Maroc qui rayonne.',
  'engagement.description': 'En tant que MRE, je suis fier(e) de contribuer activement à l\'essor de mon pays. Notre projet dépasse la simple économie : il crée du savoir-faire local, soutient nos provinces et positionne le Royaume en leader de l\'économie circulaire.',
  'engagement.mapLabel': 'Royaume du Maroc — Toutes les provinces',
  'engagement.keyPointsTitle': 'Points Clés',
  'engagement.point1Title': 'Impact Local',
  'engagement.point1Desc': 'Création d\'emplois durables dans toutes les provinces.',
  'engagement.point2Title': 'Réduction économique des importations',
  'engagement.point2Desc': 'Valorisation des ressources et compétences nationales.',
  'engagement.point3Title': 'Vitrine Technologique',
  'engagement.point3Desc': 'Positionner le Maroc comme un modèle de service responsable.',

  // Reassurance
  'reassurance.badge': 'Pourquoi Nous Choisir',
  'reassurance.badge2': 'Notre objectif',
  'reassurance.title': 'Un Partenaire',
  'reassurance.titleHighlight': 'de Confiance',
  'reassurance.titleEnd': 'pour Votre Compagnie et Aeroport',
  'reassurance.description': 'Nous combinons expertise technique, réactivité et engagement qualité pour offrir un service de réparation de bagages inégalé aux compagnies aériennes.',
  'reassurance.point1Title': 'Réactivité Express',
  'reassurance.point1Desc': 'Intervention en 1-2h directement sur le hub aéroportuaire. Vos passagers repartent avec leur bagage réparé le jour même.',
  'reassurance.point2Title': 'Qualité Certifiée',
  'reassurance.point2Desc': 'Conformité totale aux standards IATA. Chaque réparation est documentée et garantie 6 mois.',
  'reassurance.point3Title': 'Engagement Écologique',
  'reassurance.point3Desc': 'Réparer plutôt que remplacer : -80% d\'empreinte carbone. Une approche circulaire responsable.',

  // Process
  'process.badge': 'Notre Processus',
  'process.title': 'Un Processus',
  'process.titleHighlight': 'Simple et Efficace',
  'process.subtitle': 'De la réception du bagage endommagé à sa restitution, chaque étape est optimisée.',
  'process.step1Title': 'Signalement',
  'process.step1Desc': 'Le passager signale le dommage au comptoir. Notre équipe est alertée instantanément.',
  'process.step2Title': 'Diagnostic',
  'process.step2Desc': 'Inspection complète du bagage avec rapport photographique détaillé et devis transparent.',
  'process.step3Title': 'Réparation',
  'process.step3Desc': 'Intervention par nos techniciens certifiés avec pièces de qualité et techniques professionnelles.',
  'process.step4Title': 'Restitution',
  'process.step4Desc': 'Contrôle qualité rigoureux puis restitution du bagage réparé au passager satisfait.',

  // Infographic
  'infographic.title': 'Avant & Après',
  'infographic.titleHighlight': 'ABRS',
  'infographic.subtitle': 'Découvrez l\'impact concret de nos solutions sur la gestion des bagages endommagés.',
  'infographic.beforeTitle': 'AVANT ABRS',
  'infographic.beforeSubtitle': 'Gestion traditionnelle des sinistres',
  'infographic.afterTitle': 'APRÈS ABRS',
  'infographic.afterSubtitle': 'Solution intégrée DFPRO PARTNER',
  'infographic.metric1Label': 'Délai de résolution',
  'infographic.metric1Before': '7-21 jours',
  'infographic.metric1After': '1-2 heures',
  'infographic.metric1Improvement': '-95%',
  'infographic.metric2Label': 'Satisfaction passager',
  'infographic.metric2Before': '35%',
  'infographic.metric2After': '98%',
  'infographic.metric2Improvement': '+180%',
  'infographic.metric3Label': 'Impact environnemental',
  'infographic.metric3Before': 'Élevé',
  'infographic.metric3After': 'Minimal',
  'infographic.metric3Improvement': '-80%',
  'infographic.metric4Label': 'Image de marque',
  'infographic.metric4Before': 'Dégradée',
  'infographic.metric4After': 'Renforcée',
  'infographic.metric4Improvement': '+53%',
  'infographic.summaryLabel1': 'Temps de réparation',
  'infographic.summaryLabel2': 'Réduction des coûts',
  'infographic.summaryLabel3': 'Satisfaction client',
  'infographic.summaryLabel4': 'Empreinte carbone',

  // Ecosystem
  'ecosystem.badge': 'Écosystème Digital',
  'ecosystem.title': 'Notre Plateforme',
  'ecosystem.titleHighlight': 'Technologique',
  'ecosystem.subtitle': 'Un écosystème digital complet pour gérer, suivre et optimiser chaque réparation de bagage.',
  'ecosystem.block1Title': 'Suivi de Réparation en Temps Réel',
  'ecosystem.block1Desc': 'Tableau de bord interactif permettant de suivre chaque étape de la réparation. Notifications automatiques, photos avant/après et historique complet accessible 24/7.',
  'ecosystem.block2Title': 'Saisie PIR Digitalisée',
  'ecosystem.block2Desc': 'Formulaire de déclaration de dommage entièrement numérique. Capture photo intégrée, signature électronique et transmission instantanée aux équipes de réparation.',
  'ecosystem.block3Title': 'Reporting & Analytics',
  'ecosystem.block3Desc': 'Tableaux de bord analytiques avec KPIs en temps réel. Analyse des tendances, prévisions et recommandations pour optimiser vos opérations bagages.',

  // Satisfaction Guarantee
  'guarantee.badge': 'Garantie Satisfaction',
  'guarantee.title': 'Notre Engagement',
  'guarantee.titleHighlight': 'Qualité Totale',
  'guarantee.subtitle': 'Chaque réparation ABRS est couverte par notre',
  'guarantee.subtitleBold': 'double garantie exclusive',
  'guarantee.warrantyText1': 'Garantie 2 Ans',
  'guarantee.warrantyText2': 'Même hors garantie constructeur',
  'guarantee.qualityBadge': 'Qualité Certifiée IATA',
  'guarantee.step1Title': 'Garantie Pièces & Main d\'Œuvre',
  'guarantee.step1Desc': 'Toutes nos réparations sont garanties 2 ans, pièces et main d\'œuvre incluses. Si un défaut apparaît, nous intervenons gratuitement.',
  'guarantee.step1Badge': 'Inclus',
  'guarantee.step2Title': 'Remplacement si Irréparable',
  'guarantee.step2Desc': 'Si le bagage est jugé irréparable après diagnostic, nous assurons son remplacement par un modèle équivalent ou supérieur.',
  'guarantee.step2Badge': 'Premium',
  'guarantee.missionBadge': 'Notre Mission',
  'guarantee.missionQuote': 'Nous ne réparons pas seulement des bagages, nous restaurons la',
  'guarantee.missionHighlight1': 'confiance',
  'guarantee.missionAnd': 'et la',
  'guarantee.missionHighlight2': 'sérénité',
  'guarantee.missionEnd': 'de chaque passager. C\'est notre',
  'guarantee.missionHighlight3': 'engagement quotidien',
  'guarantee.trustIndicator1': 'Certifié IATA',
  'guarantee.trustIndicator2': 'Disponible 24/7',
  'guarantee.trustIndicator3': '98% Satisfaction',

  // Partners
  'partners.badge': 'Nos Valeurs',
  'partners.title': 'L\'Excellence au Service',
  'partners.titleHighlight': 'de l\'Aviation',
  'partners.subtitle': 'Des valeurs fortes qui guident chacune de nos interventions et garantissent un service d\'exception.',
  'partners.value1Title': 'Réactivité',
  'partners.value1Desc': 'Intervention en 1-2h',
  'partners.value2Title': 'Fiabilité',
  'partners.value2Desc': 'Certifié IATA',
  'partners.value3Title': 'Support',
  'partners.value3Desc': 'Disponible 24/7',
  'partners.value4Title': 'Logistique',
  'partners.value4Desc': 'Livraison premium',
  'partners.stat1': 'Objectif satisfaction',
  'partners.stat2': 'Disponibilité',
  'partners.stat3': 'Solution innovante',
  'partners.trustBadge': 'Nouvelle solution pour les compagnies aériennes',

  // Testimonial
  'testimonial.badge': 'IATA Certified',
  'testimonial.badgeDesc': 'Conformité totale',
  'testimonial.quote': 'ABRS propose une solution innovante pour transformer la gestion des sinistres bagages. Notre',
  'testimonial.quoteHighlight': 'réactivité et expertise',
  'testimonial.quoteEnd': ' permettront de réduire vos coûts jusqu\'à 65% tout en améliorant la satisfaction de vos passagers.',
  'testimonial.optimizedFor': 'Optimisé pour les compagnies aériennes',
  'testimonial.companies': 'Solution professionnelle B2B',
  'testimonial.readyFor': 'Prêt pour votre compagnie',
  'testimonial.value1Title': 'Économies Significatives',
  'testimonial.value1Desc': 'Réduction estimée de 88% des coûts par rapport au remplacement systématique.',
  'testimonial.value2Title': 'Conformité Garantie',
  'testimonial.value2Desc': 'Documentation complète et traçabilité pour chaque intervention.',
  'testimonial.value3Title': 'Impact Écologique',
  'testimonial.value3Desc': '-80% d\'empreinte carbone grâce à la réparation plutôt que le remplacement.',

  // Eco Impact
  'ecoImpact.badge': 'Impact Environnemental',
  'ecoImpact.title': 'Notre Engagement',
  'ecoImpact.titleHighlight': 'Écologique',
  'ecoImpact.subtitle': 'Chaque bagage réparé est un bagage sauvé de la décharge. Notre approche circulaire réduit considérablement l\'empreinte carbone.',
  'ecoImpact.metric1': 'Objectif bagages réparés',
  'ecoImpact.metric2': 'Déchets évités par an',
  'ecoImpact.metric3': 'CO₂ économisé par an',
  'ecoImpact.metric4': 'Taux de réparabilité visé',
  'ecoImpact.metric5': 'Objectif satisfaction',
  'ecoImpact.noteTitle': 'Économie circulaire :',
  'ecoImpact.noteText': 'Chaque réparation contribue à réduire les déchets et l\'empreinte carbone de l\'industrie aérienne.',

  // International Presence
  'international.heroBadge': 'Fierté Marocaine',
  'international.heroTitle': 'Né au Maroc,',
  'international.heroTitleHighlight': 'Rayonnant à l\'International',
  'international.heroDesc': 'Depuis Casablanca, nous exportons notre savoir-faire et notre excellence vers l\'Europe et le monde.',
  'international.badge': 'Présence Internationale',
  'international.title': 'Un Réseau',
  'international.titleHighlight': 'en Expansion',
  'international.subtitle': 'Deux pôles d\'expertise complémentaires pour servir les compagnies aériennes à travers le monde.',
  'international.europeTitle': 'DFPRO EUROPE',
  'international.europeSubtitle': 'Siège Européen — Belgique',
  'international.europeDesc': 'Notre filiale européenne gère les opérations sur les principaux hubs du continent, avec une expertise reconnue dans la gestion des sinistres bagages.',
  'international.europePoint1': 'Présence sur les aéroports de Bruxelles, Charleroi, Genève',
  'international.europePoint2': 'Partenariats avec les compagnies européennes',
  'international.europePoint3': 'Conformité aux réglementations EU',
  'international.internationalTitle': 'Expansion Mondiale',
  'international.internationalSubtitle': 'Gibraltar, USA, UAE',
  'international.internationalDesc': 'Notre expertise s\'étend au-delà de l\'Europe avec des opérations en Amérique du Nord, au Moyen-Orient et en Afrique.',
  'international.internationalPoint1': 'Présence à Gibraltar, Houston (Texas), Dubaï',
  'international.internationalPoint2': 'Adaptation aux standards locaux',
  'international.internationalPoint3': 'Support multilingue 24/7',

  // CTA
  'cta.badge': 'Passez à l\'Action',
  'cta.title': 'Prêt à Optimiser',
  'cta.titleHighlight': 'Vos Coûts Bagages ?',
  'cta.description': 'Contactez-nous pour une étude personnalisée et découvrez combien vous pouvez économiser avec ABRS.',
  'cta.benefit1': 'Réduction estimée de 88% des coûts de sinistres',
  'cta.benefit2': 'Intervention express en 1-2 heures',
  'cta.benefit3': 'Plateforme de suivi en temps réel',
  'cta.benefit4': 'Conformité IATA garantie',
  'cta.ctaPrimary': 'Demander un devis gratuit',
  'cta.ctaSecondary': 'Télécharger notre brochure',
  'cta.deploymentTitle': 'Lancement imminent',
  'cta.deploymentDesc': 'Déploiement en cours',

  // Footer
  'footer.tagline': 'Expert en réparation de bagages aéroportuaires.',
  'footer.description': 'Service professionnel, rapide et garanti pour les compagnies aériennes. Présence internationale avec siège au Maroc.',
  'footer.newsletterTitle': 'Restez Informé',
  'footer.newsletterDesc': 'Recevez nos actualités et innovations en réparation de bagages.',
  'footer.newsletterPlaceholder': 'Votre email professionnel',
  'footer.newsletterSuccess': 'Inscription réussie !',
  'footer.teamTitle': 'Notre Équipe à Votre Service',
  'footer.teamDesc': 'Une équipe passionnée et experte, dédiée à l\'excellence du service.',
  'footer.contactTitle': 'Nos Bureaux Internationaux',
  'footer.contactBelgium': 'Belgique',
  'footer.contactMorocco': 'Maroc',
  'footer.contactEmailBelgium': 'Email Belgique',
  'footer.contactEmailMorocco': 'Email Maroc',
  'footer.solutionsTitle': 'Solutions',
  'footer.solution1': 'Fast-Track Aéroport',
  'footer.solution2': 'Gestion des Sinistres',
  'footer.solution3': 'Logistique Premium',
  'footer.solution4': 'Plateforme SaaS',
  'footer.companyTitle': 'Entreprise',
  'footer.company1': 'À Propos',
  'footer.company2': 'Carrières',
  'footer.company3': 'Partenaires',
  'footer.company4': 'Presse',
  'footer.resourcesTitle': 'Ressources',
  'footer.resource1': 'Documentation',
  'footer.resource2': 'Blog',
  'footer.resource3': 'FAQ',
  'footer.resource4': 'Support',
  'footer.copyright': 'Tous droits réservés.',
  'footer.privacy': 'Politique de confidentialité',
  'footer.terms': 'Conditions générales',
  'footer.poweredBy': 'Powered by Readdy',

  // Contact Page
  'contactPage.heroBadge': 'Contactez-nous',
  'contactPage.heroTitle': 'Parlons de Votre',
  'contactPage.heroTitleHighlight': 'Projet Ensemble',
  'contactPage.heroDesc': 'Notre équipe d\'experts est à votre disposition pour étudier vos besoins et vous proposer une solution sur mesure.',
  'contactPage.info1Title': 'Nos Bureaux',
  'contactPage.info2Title': 'Téléphone',
  'contactPage.info3Title': 'Email',
  'contactPage.info4Title': 'Horaires',
  'contactPage.info4Line1': 'Lun-Ven : 8h00 - 18h00',
  'contactPage.info4Line2': 'Urgences : 24/7',
  'contactPage.formSideTitle': 'Pourquoi Choisir',
  'contactPage.formSideTitleHighlight': 'ABRS ?',
  'contactPage.formSideDesc': 'Découvrez les avantages concrets d\'un partenariat avec Air Baggage Repair Solutions.',
  'contactPage.advantage1Title': 'Réponse en 24h',
  'contactPage.advantage1Desc': 'Notre équipe commerciale vous répond sous 24 heures ouvrées.',
  'contactPage.advantage2Title': 'Économies estimées de 88%',
  'contactPage.advantage2Desc': 'Réduction drastique des coûts par rapport au remplacement.',
  'contactPage.advantage3Title': 'Certifié IATA',
  'contactPage.advantage3Desc': 'Conformité totale aux standards internationaux.',
  'contactPage.advantage4Title': 'Support Dédié',
  'contactPage.advantage4Desc': 'Un account manager dédié pour votre compagnie.',
  'contactPage.advantage5Title': 'Reporting Complet',
  'contactPage.advantage5Desc': 'Tableaux de bord et analytics en temps réel.',
  'contactPage.urgencyLabel': 'Ligne Urgence',
  'contactPage.urgencyDesc': 'Pour les urgences aéroportuaires, nos équipes sont disponibles 24/7.',
  'contactPage.formTitle': 'Demander un Devis',
  'contactPage.formSubtitle': 'Remplissez le formulaire ci-dessous et nous vous recontacterons rapidement.',
  'contactPage.labelFirstName': 'Prénom',
  'contactPage.placeholderFirstName': 'Votre prénom',
  'contactPage.labelLastName': 'Nom',
  'contactPage.placeholderLastName': 'Votre nom',
  'contactPage.labelEmail': 'Email',
  'contactPage.placeholderEmail': 'votre@email.com',
  'contactPage.labelPhone': 'Téléphone',
  'contactPage.placeholderPhone': '+32 ...',
  'contactPage.labelCompany': 'Entreprise',
  'contactPage.placeholderCompany': 'Nom de votre compagnie',
  'contactPage.labelPosition': 'Poste',
  'contactPage.placeholderPosition': 'Votre fonction',
  'contactPage.labelService': 'Service souhaité',
  'contactPage.selectService': 'Sélectionnez un service',
  'contactPage.labelVolume': 'Volume estimé',
  'contactPage.selectVolume': 'Sélectionnez un volume',
  'contactPage.labelMessage': 'Message',
  'contactPage.placeholderMessage': 'Décrivez votre besoin...',
  'contactPage.charCount': 'caractères',
  'contactPage.rgpdText': 'J\'accepte que mes données soient traitées conformément à la',
  'contactPage.rgpdLink': 'politique de confidentialité',
  'contactPage.submitting': 'Envoi en cours...',
  'contactPage.submitButton': 'Envoyer ma demande',
  'contactPage.errorMessage': 'Une erreur est survenue. Veuillez réessayer.',
  'contactPage.successTitle': 'Demande Envoyée !',
  'contactPage.successDesc': 'Notre équipe vous recontactera sous 24 heures ouvrées.',
  'contactPage.successButton': 'Envoyer une autre demande',

  // Services Page
  'servicesPage.heroBadge': 'Nos Services Professionnels',
  'servicesPage.heroTitle': 'Solutions Complètes de',
  'servicesPage.heroTitleHighlight': 'Réparation Bagages',
  'servicesPage.heroDesc': 'Une gamme complète de services B2B pour les compagnies aériennes, de la réparation express à la gestion intégrée des sinistres.',
  'servicesPage.heroCtaPrimary': 'Demander un devis',
  'servicesPage.heroCtaSecondary': 'Nous appeler',
  'servicesPage.listTitle': 'Nos Services',
  'servicesPage.listTitleHighlight': 'en Détail',
  'servicesPage.listSubtitle': 'Découvrez l\'ensemble de nos solutions adaptées aux besoins des compagnies aériennes.',
  'servicesPage.service1Title': 'Fast-Track Aéroport',
  'servicesPage.service1Desc': 'Réparation express directement en zone aéroportuaire. Notre équipe intervient en 1-2h pour minimiser l\'impact sur vos passagers et vos opérations.',
  'servicesPage.service1Feature1': 'Intervention en 1-2 heures sur site',
  'servicesPage.service1Feature2': 'Atelier mobile en zone aéroportuaire',
  'servicesPage.service1Feature3': 'Rapport photo avant/après',
  'servicesPage.service1Feature4': 'Pièces de rechange premium',
  'servicesPage.service2Title': 'Gestion des Sinistres',
  'servicesPage.service2Desc': 'Prise en charge complète des réclamations bagages, de la déclaration PIR à la résolution finale avec reporting détaillé.',
  'servicesPage.service2Feature1': 'Déclaration PIR digitalisée',
  'servicesPage.service2Feature2': 'Suivi en temps réel',
  'servicesPage.service2Feature3': 'Communication passager automatisée',
  'servicesPage.service2Feature4': 'Reporting analytique mensuel',
  'servicesPage.service3Title': 'Contrat de Maintenance',
  'servicesPage.service3Desc': 'Programme de maintenance préventive et corrective pour optimiser la durée de vie des équipements bagages.',
  'servicesPage.service3Feature1': 'Inspections régulières planifiées',
  'servicesPage.service3Feature2': 'Maintenance préventive',
  'servicesPage.service3Feature3': 'Remplacement pièces d\'usure',
  'servicesPage.service3Feature4': 'Rapport d\'état trimestriel',
  'servicesPage.service4Title': 'Logistique & Livraison',
  'servicesPage.service4Desc': 'Service de collecte et livraison premium. Vos passagers récupèrent leur bagage réparé où ils le souhaitent.',
  'servicesPage.service4Feature1': 'Collecte à domicile ou hôtel',
  'servicesPage.service4Feature2': 'Livraison express 24-48h',
  'servicesPage.service4Feature3': 'Suivi GPS en temps réel',
  'servicesPage.service4Feature4': 'Emballage sécurisé',
  'servicesPage.service5Title': 'Atelier de Réparation',
  'servicesPage.service5Desc': 'Notre atelier central équipé des dernières technologies pour les réparations complexes nécessitant un environnement contrôlé.',
  'servicesPage.service5Feature1': 'Équipement professionnel de pointe',
  'servicesPage.service5Feature2': 'Techniciens certifiés',
  'servicesPage.service5Feature3': 'Stock de pièces détachées',
  'servicesPage.service5Feature4': 'Contrôle qualité rigoureux',
  'servicesPage.service6Title': 'Solutions Sur Mesure',
  'servicesPage.service6Desc': 'Des solutions personnalisées adaptées aux besoins spécifiques de votre compagnie aérienne.',
  'servicesPage.service6Feature1': 'Audit de vos processus actuels',
  'servicesPage.service6Feature2': 'Proposition de solution adaptée',
  'servicesPage.service6Feature3': 'Intégration avec vos systèmes',
  'servicesPage.service6Feature4': 'Formation de vos équipes',
  'servicesPage.learnMore': 'En savoir plus',
  'servicesPage.pricingBadge': 'Tarification',
  'servicesPage.pricingTitle': 'Des Formules',
  'servicesPage.pricingTitleHighlight': 'Adaptées',
  'servicesPage.pricingTitleEnd': 'à Vos Besoins',
  'servicesPage.pricingSubtitle': 'Choisissez la formule qui correspond le mieux à votre volume et vos besoins.',
  'servicesPage.plan1Name': 'Essentiel',
  'servicesPage.plan1Desc': 'Pour les compagnies avec un volume modéré',
  'servicesPage.plan1Price': 'Sur devis',
  'servicesPage.plan2Name': 'Business',
  'servicesPage.plan2Desc': 'La solution la plus populaire',
  'servicesPage.plan2Price': 'Sur devis',
  'servicesPage.plan3Name': 'Enterprise',
  'servicesPage.plan3Desc': 'Pour les grandes compagnies',
  'servicesPage.plan3Price': 'Sur devis',
  'servicesPage.recommended': 'Recommandé',
  'servicesPage.planCta': 'Demander un devis',
  'servicesPage.pricingNote': 'Tous les tarifs sont personnalisés en fonction de votre volume et de vos besoins spécifiques.',
  'servicesPage.processBadge': 'Notre Processus',
  'servicesPage.processTitle': 'Comment Ça',
  'servicesPage.processTitleHighlight': 'Fonctionne',
  'servicesPage.processSubtitle': 'Un processus simple et transparent en 4 étapes.',
  'servicesPage.processStep1': 'Diagnostic',
  'servicesPage.processStep1Desc': 'Inspection complète du bagage et évaluation détaillée des dommages.',
  'servicesPage.processStep2': 'Devis',
  'servicesPage.processStep2Desc': 'Proposition de réparation avec devis transparent et détaillé.',
  'servicesPage.processStep3': 'Réparation',
  'servicesPage.processStep3Desc': 'Intervention par nos techniciens certifiés avec pièces de qualité.',
  'servicesPage.processStep4': 'Livraison',
  'servicesPage.processStep4Desc': 'Contrôle qualité et restitution du bagage réparé.',
  'servicesPage.ctaBadge': 'Prêt à Commencer ?',
  'servicesPage.ctaTitle': 'Optimisez Votre',
  'servicesPage.ctaTitleHighlight': 'Gestion Bagages',
  'servicesPage.ctaTitleEnd': 'Dès Aujourd\'hui',
  'servicesPage.ctaDesc': 'Contactez notre équipe pour une étude personnalisée de vos besoins.',
  'servicesPage.ctaPrimary': 'Demander un devis',
  'servicesPage.ctaSecondary': 'Nous appeler',
  'servicesPage.trustIndicator1': 'Certifié IATA',
  'servicesPage.trustIndicator2': 'Disponible 24/7',
  'servicesPage.trustIndicator3': 'Présence internationale',
};

export default common;
